import { createContext } from "react";
const TradathonContext = createContext();
export default TradathonContext;
